import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=ecb7d67c&scoped=true&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=ecb7d67c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb7d67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecb7d67c')) {
      api.createRecord('ecb7d67c', component.options)
    } else {
      api.reload('ecb7d67c', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=ecb7d67c&scoped=true&", function () {
      api.rerender('ecb7d67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Comment.vue"
export default component.exports